import {
    getBillableUnit,
    listBillableUnits
} from './queries';
import {
    createBillableUnit,
    deleteBillableUnit,
    updateBillableUnit,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {BillableUnit} from "../types.ts";
import {billingApiClient} from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListBillableUnits = {
    listBillableUnits: { items: BillableUnit[], nextToken: string }
}

export type GetBillableUnit = {
    getBillableUnit: BillableUnit
}

export type CreateBillableUnit = {
    createBillableUnit: BillableUnit
}

export type UpdateBillableUnit = {
    updateBillableUnit: BillableUnit
}

export type DeleteBillableUnit = {
    deleteBillableUnit: string
}


const client = billingApiClient;

export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListBillableUnits>>({
        query: listBillableUnits,
        variables: {
            ...query
        },
    });
    return {
        items: response.data?.listBillableUnits.items,
        nextToken: response.data?.listBillableUnits.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetBillableUnit>>({
        query: getBillableUnit,
        variables: {id: id},
    });
    return response.data?.getBillableUnit;
};

export const add = async (payload: BillableUnit) => {
    // WHITELIST the mutation variables, never blacklist: the record carries a resolved
    // `meter` object and audit fields that CreateBillableUnitInput does not accept, and
    // AppSync rejects the whole mutation on an unknown field.
    const input = {
        name: payload.name,
        description: payload.description,
        meterId: payload.meterId,
        meteredUnitsPerBillableUnit: payload.meteredUnitsPerBillableUnit,
        status: payload.status,
    };

    const response = await client.graphql<GraphQLQuery<CreateBillableUnit>>(
        {
            query: createBillableUnit,
            variables: {input},
        });
    return response.data?.createBillableUnit;
};

export const update = async (id: string, record: BillableUnit) => {
    // Same whitelist discipline as add(). `meter` in particular is a server-resolved
    // object — echoing it back would fail the mutation.
    const input = {
        id: id,
        name: record.name,
        description: record.description,
        meterId: record.meterId,
        meteredUnitsPerBillableUnit: record.meteredUnitsPerBillableUnit,
        status: record.status,
    };

    const response = await client.graphql<GraphQLQuery<UpdateBillableUnit>>({
        query: (updateBillableUnit),
        variables: {input},
    });
    return response.data?.updateBillableUnit;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteBillableUnit>>({
        query: (deleteBillableUnit),
        variables: {input: {id: id}},
    });
    return response.data?.deleteBillableUnit;
};
